import {DeviceApi, FleetApi, OrganizationApi, VehicleApi} from '@/api'

const organizationApi = new OrganizationApi()
const fleetApi = new FleetApi()
const deviceApi = new DeviceApi()
const vehicleApi = new VehicleApi()

export default {
    async moveItem (sourceType, sourceId, destinationType, destinationId) {
        switch (sourceType) {
            case 'Organization':
                await organizationApi.move([{
                    'organizationId': sourceId,
                    'organizationParentId': destinationId
                }])
                break
            case 'Fleet':
                await fleetApi.move([
                    {
                        'fleetId': sourceId,
                        'organizationId': destinationId
                    }
                ])
                break
            case 'Vehicle':
                await vehicleApi.move([
                    {
                        'vehicleId': sourceId,
                        'fleetId': destinationId
                    }
                ])
                break
            case 'Device':
                await deviceApi.move([
                    {
                        'deviceId': sourceId,
                        'parentId': destinationId,
                        'level': this.mapTypeToNumber(destinationType)
                    }
                ])
                break
        }
    },

    mapTypeToNumber (type) {
        switch (type) {
            case 'Organization':
                return 0
            case 'Fleet':
                return 1
            case 'Vehicle':
                return 2
            case 'Device':
                return 3
        }
    }
}
